import styled from "styled-components";
import { Wrapper, wrap } from 'AppReact';

const template = styled.div`
  min-height: 500px;
  border: 1px solid #E3E3E3;
  border-radius: 12px;
  min-width: 55em;
  display: flex;
  flex-direction: column;
  padding: 15px 22px;
  width: -webkit-fill-available;
  @media screen and (max-width: 1440px){
    min-width: 40em;
  }
  @media screen and (max-width: 768px){
    min-width: 25em;
    border: 0px solid #E3E3E3;
    padding: 0px 0px;
  }
`;

export default Wrapper(template);
